import { useCallback } from 'react';
import { store } from 'redux/store';
import {
  reset,
} from 'redux/reducers/meteorologyWeatherComparatorControlPanelReducer';

export default function useClearSelection() {
  const clearSelection = useCallback(() => {
    store.dispatch(reset());
  }, []);

  return clearSelection;
}
